import { USER_RIGHTS } from '../consts';

const checkUserAuthorization = (userRole, actions = []) => {
	if (Array.isArray(actions)) return actions.some((action) => USER_RIGHTS[userRole].includes(action));
	else return USER_RIGHTS[userRole].includes(actions);
};

export default checkUserAuthorization;
